var _defs, _circle, _g, _rect, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;}.cls-5{stroke-miterlimit:10;stroke-width:4px;}.cls-6{stroke-miterlimit:10;stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6-2",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_156",
    "data-name": "Path 156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,109.29A51.59,51.59,0,0,1,4.88,57.63,51.63,51.63,0,0,1,93.06,21.11a51.68,51.68,0,0,1-16.42,84.12A51.22,51.22,0,0,1,56.53,109.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.53,8A49.65,49.65,0,0,0,21.42,92.75,49.67,49.67,0,1,0,56.53,8m0-4A53.66,53.66,0,1,1,2.88,57.63,53.66,53.66,0,0,1,56.53,4Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-5",
    d: "M78.79,74.78a26,26,0,1,1,.85-33.55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    className: "cls-1",
    x: 41.32,
    y: 39.78,
    width: 35.45,
    height: 17.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-6",
    d: "M73.33,68.78a22.64,22.64,0,0,0-14.74-5.07c-5.5,0-9.38,1.95-13.59,5.46"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.add77bcc284dcb9ccc3bab3c4766814b.svg";
export { ForwardRef as ReactComponent };